import { Image, Space } from "antd";
import SummaryWrapper from "../SummaryWrapper";
import React from "react";
import {
  getLabelTag,
  getLabelTagInput,
  getLabelTagYesNO,
  getLabelTagsArray,
  getLabelTagsWithDescription,
  getLabelTagsWithDynamicInputs,
  getPastMedicalHistorySummary,
} from "../constructTextFromValues";
import {
  alcoholOptions,
  chiefComplaintsOptions,
  educationalOptions,
  functionalOptions,
  informantOptions,
  knownAllergiesOptions,
  maritalStatusOptions,
  medicalTreatmentOptions,
  modeOfArrivalOptions,
  pastMedicalOptions,
  presentIllnessOptions,
  relationOptions,
  smokingOptions,
  surgicalTreatmentOptions,
} from "../../Options/historyOptions";
import HistoryIcon from "../../../../assets/images/nurseIcons/history.svg";
import { checkEmpty } from "../../../../helpers/utility";

const NurseHistorySummary = ({ formData }) => {
  const constructHistorySummaryItems = () => {
    const historySummaryItems = [];
    const history = formData?.history || {};
    const pushHistoryItem = (key, label, children) => {
      historySummaryItems.push({ key, label, children });
    };

    if (history.mode_of_arrival) {
      pushHistoryItem(
        "1",
        "Mode of Arrival",
        <>{getLabelTag(modeOfArrivalOptions, history?.mode_of_arrival)}</>
      );
    }
    if (
      history.informant ||
      history.relation_with_patient ||
      history.informant_name
    ) {
      pushHistoryItem(
        "2",
        "Informant",
        <>
          {getLabelTag(informantOptions, history?.informant)}
          {getLabelTag(relationOptions, history?.relation_with_patient)}
          {getLabelTagInput(
            "Others details",
            history?.relation_with_patient_others
          )}
          {getLabelTagInput("Name", history?.informant_name)}
        </>
      );
    }
    if (history.chief_complaints || history?.chief_complaints_others) {
      pushHistoryItem(
        "3",
        "Chief Complaints",
        <>
          {getLabelTagsArray(
            chiefComplaintsOptions,
            history.chief_complaints,
          )}
          {getLabelTagsWithDynamicInputs(history?.chief_complaints_others)}
        </>
      );
    }
    if (
      getLabelTagsWithDescription(presentIllnessOptions, history)?.length > 0 ||
      checkEmpty(history?.present_illness_others)
    ) {
      pushHistoryItem(
        "4",
        "Present Illness",
        <>
          {getLabelTagsWithDescription(presentIllnessOptions, history)}
          {getLabelTagsWithDynamicInputs(history?.present_illness_others)}
        </>
      );
    }
    if (
      getLabelTagsWithDescription(
        medicalTreatmentOptions,
        history?.treatment_history
      )?.length > 0 ||
      checkEmpty(history?.treatment_history?.medical_treatment_others)
    ) {
      pushHistoryItem(
        "5",
        "Medical Treatment History",
        <>
          {getLabelTagsWithDescription(
            medicalTreatmentOptions,
            history?.treatment_history
          )}
          {getLabelTagsWithDynamicInputs(
            history?.treatment_history?.medical_treatment_others
          )}
        </>
      );
    }
    if (
      getLabelTagsWithDescription(
        surgicalTreatmentOptions,
        history?.treatment_history
      )?.length > 0 ||
      checkEmpty(history?.treatment_history?.surgical_treatment_others)
    ) {
      pushHistoryItem(
        "6",
        "Surgical Treatment History",
        <>
          {getLabelTagsWithDescription(
            surgicalTreatmentOptions,
            history?.treatment_history
          )}
          {getLabelTagsWithDynamicInputs(
            history?.treatment_history?.surgical_treatment_others
          )}
        </>
      );
    }
    if (getPastMedicalHistorySummary(pastMedicalOptions, history)?.length > 0) {
      pushHistoryItem(
        "7",
        "Past Medical History",
        getPastMedicalHistorySummary(pastMedicalOptions, history)
      );
    }
    if (history.surgical_history || history.surgical_history_details) {
      pushHistoryItem(
        "8",
        "Past Surgical History",
        <>
          {getLabelTagYesNO(history.surgical_history)}
          {getLabelTagInput("Details", history.surgical_history_details)}
        </>
      );
    }
    if (
      history.marital_status ||
      history.education ||
      history.smoking ||
      history.alcohol
    ) {
      pushHistoryItem(
        "9",
        "Personal History",
        <>
          {getLabelTag(maritalStatusOptions, history.marital_status)}
          {getLabelTag(educationalOptions, history.education)}
          {getLabelTag(smokingOptions, history.smoking)}
          {getLabelTagInput("Smoking since", history?.smoking_since, "yrs")}
          {getLabelTagInput(
            "Stopped smoking since",
            history?.stopped_smoking_since,
            "yrs"
          )}
          {getLabelTag(alcoholOptions, history.alcohol)}
        </>
      );
    }
    if (history.functional_capacity) {
      pushHistoryItem(
        "10",
        "Previous Functional Capacity",
        getLabelTag(functionalOptions, history.functional_capacity)
      );
    }
    if (
      getLabelTagsWithDescription(knownAllergiesOptions, history)?.length > 0 ||
      checkEmpty(history?.known_allergies_others)
    ) {
      pushHistoryItem(
        "11",
        "Known Allergies",
        <>
          {getLabelTagsWithDescription(knownAllergiesOptions, history)}
          {getLabelTagsWithDynamicInputs(history?.known_allergies_others)}
        </>
      );
    }
    return historySummaryItems;
  };

  const historySummaryItems = constructHistorySummaryItems();
  return (
    <>
      {historySummaryItems.length !== 0 && (
        <SummaryWrapper
          collapseAllOnMobile
          items={historySummaryItems}
          title={
            <span style={{ fontWeight: "500", marginLeft: ".2rem" }}>
              <Space>
                <Image src={HistoryIcon} preview={false} />
                <span>History</span>
              </Space>
            </span>
          }
        />
      )}
    </>
  );
};

export default NurseHistorySummary;
